<template>
  <button
    type="button"
    class="smardie-accordion-toggle"
    :class="alignClass"
    :aria-expanded="expanded ? 'true' : 'false'"
    @click="$emit('toggle')"
  >
    <i
      class="chevron icon"
      :class="expanded ? 'up' : 'down'"
      aria-hidden="true"
    ></i>
    <span class="smardie-accordion-toggle__label">{{ label }}</span>
  </button>
</template>

<script>
export default {
  name: 'AccordionToggle',
  props: {
    expanded: {
      type: Boolean,
      default: false
    },
    expandedLabel: {
      type: String,
      default: 'Collapse'
    },
    collapsedLabel: {
      type: String,
      default: 'Expand'
    },
    /** Horizontal alignment: start | center | end */
    align: {
      type: String,
      default: 'start',
      validator: function (value) {
        return ['start', 'center', 'end'].indexOf(value) !== -1
      }
    }
  },
  computed: {
    label: function () {
      return this.expanded ? this.expandedLabel : this.collapsedLabel
    },
    alignClass: function () {
      return 'smardie-accordion-toggle--' + this.align
    }
  }
}
</script>

<style scoped>
/* Link medium (14px #4DA1FF), no underline — scoped so HMR can't drop it */
.smardie-accordion-toggle {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin: 0;
  padding: 0;
  border: none;
  background: none;
  font-family: var(--font-regular);
  font-size: 14px;
  line-height: 17px;
  color: #4DA1FF !important;
  text-decoration: none !important;
  cursor: pointer;
  white-space: nowrap;
}
.smardie-accordion-toggle:hover,
.smardie-accordion-toggle:focus {
  color: var(--color-primary) !important;
  text-decoration: none !important;
}
.smardie-accordion-toggle .icon,
.smardie-accordion-toggle__label {
  text-decoration: none !important;
  color: inherit !important;
}
.smardie-accordion-toggle .icon {
  margin: 0 !important;
  font-size: 14px;
  line-height: 17px;
}
.smardie-accordion-toggle--start {
  justify-content: flex-start;
}
.smardie-accordion-toggle--center {
  width: 100%;
  justify-content: center;
}
.smardie-accordion-toggle--end {
  justify-content: flex-end;
  flex-shrink: 0;
}
</style>
